import axios from 'axios';
//import { getCookie } from './Cookie';

// 사용방법
// request : 'GET', 'POST', 'PUT', 'DELETE'
// url : (ex. auth/kakao-login) REACT_APP_WEB_URL은 생략
// payload :
// ex. {
//    name: 'jinkyeong',
//    code: 'abcde',
//    ...
// }

const axiosWrapper = (request, url, payload = '') => {
    const axiosInstance = axios.create({
        headers: {
            'Content-Type': 'application/json'
        }
    });

    return axiosInstance.request({
        method: request,
        url: `${process.env.REACT_APP_API_URL}/${url}`,
        data: JSON.stringify(payload),
        withCredentials: true
    });
}

export default axiosWrapper;
